import { createContext, useContext, useEffect } from "react";
import { useLocalStorage } from "@apac/hooks";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import {
  hsbcPromotionsApi,
  type Promotion,
} from "@b2bportal/hsbc-promotions-api";
import { axiosInstance } from "@hopper-b2b/api";
import { logger } from "@hopper-b2b/datadog";
import { useAuth } from "@hsbc/auth";

export const PromotionsContext = createContext<Promotion[]>([]);
export const usePromotions = () => useContext(PromotionsContext);

// TODO: Both the Context and LocalStorage are possibly not needed. Depending on usage,
// we could potentially remove the Context and use the storage call directly in the consumer
export const PromotionsProvider = ({ children }: PlatformComponentProps) => {
  const { isLoggedIn } = useAuth();
  const [promotions, setPromotions] = useLocalStorage<Promotion[]>(
    "hsbc-promotions",
    []
  );

  useEffect(() => {
    if (!isLoggedIn) return;

    const fetchPromotions = async () => {
      try {
        const response =
          await hsbcPromotionsApi(axiosInstance).apiV0PromotionsGet();
        if (response.status === 200) {
          const { eligiblePromotions } = response.data;
          setPromotions(eligiblePromotions);
        }
      } catch (error) {
        logger().error("Error fetching promotions:", { error });
      }
    };

    fetchPromotions();
  }, [isLoggedIn, setPromotions]);

  return (
    <PromotionsContext.Provider value={promotions}>
      {children}
    </PromotionsContext.Provider>
  );
};
